{
  "accountBlocked": "اکاؤنٹ بلاک کر دیا گیا ہے",
  "accountInactive": "اکاؤنٹ غیر فعال ہے",
  "alreadyHaveAccount": "پہلے سے اکاؤنٹ ہے؟",
  "backToLogin": "لاگ ان پر واپس جائیں",
  "backupCode": "بیک اپ کوڈ",
  "confirmPassword": "پاس ورڈ کی تصدیق کریں",
  "continue": "جاری رکھیں",
  "createAccount": "اکاؤنٹ بنائیں",
  "creatingAccount": "اکاؤنٹ بنایا جا رہا ہے...",
  "dontHaveAccount": "اکاؤنٹ نہیں ہے؟",
  "email": "ای میل",
  "emailAddress": "ای میل ایڈریس",
  "emailAlreadyExists": "یہ ای میل پہلے سے موجود ہے",
  "emailNotVerified": "ای میل کی تصدیق نہیں ہوئی",
  "enter2FACode": "6 ہندسوں کا توثیقی کوڈ درج کریں",
  "forgotPassword": "پاس ورڈ بھول گئے",
  "invalid2FACode": "توثیقی کوڈ غلط ہے",
  "invalidCredentials": "ای میل یا پاس ورڈ غلط ہے",
  "loggingIn": "لاگ ان ہو رہا ہے...",
  "login": "لاگ اِن",
  "loginNow": "ابھی لاگ ان کریں",
  "loginProtected": "آپ کا اکاؤنٹ گوگل آتھینٹیکیٹر سے محفوظ ہے۔",
  "loginRequired": "قیمت الرٹ بنانے کے لیے براہ کرم لاگ ان کریں۔",
  "loginSuccessful": "لاگ ان کامیاب",
  "logout": "لاگ آؤٹ",
  "password": "پاس ورڈ",
  "pleaseWait": "براہ کرم انتظار کریں...",
  "rememberMe": "مجھے یاد رکھیں",
  "resetPassword": "پاس ورڈ ری سیٹ کریں",
  "sendCode": "کوڈ بھیجیں",
  "sending": "بھیجا جا رہا ہے...",
  "sessionExpired": "سیشن ختم ہو گیا ہے۔ براہ کرم دوبارہ لاگ ان کریں۔",
  "signup": "سائن اَپ",
  "signupNow": "ابھی سائن اپ کریں",
  "signupSuccessful": "اکاؤنٹ کامیابی سے بن گیا",
  "twoFactorAuthentication": "دو مرحلہ توثیق",
  "verify": "تصدیق کریں",
  "verify2FA": "2FA کی تصدیق کریں",
  "verifyEmail": "ای میل ویری فائی کریں",
  "verifyResetCode": "ری سیٹ کوڈ کی تصدیق کریں"
}